__turbopack_context__.v({
  "className": "jetbrains_mono_651c8f9e-module__V5_UoG__className",
});
